import { useEffect, useState, useCallback } from 'preact/hooks'
import { log } from 'core/helpers'

const loadGoogleRecaptchaScript = (apiKey: string, onLoad: () => void) => {
  const script = document.createElement('script')

  script.src = `https://www.google.com/recaptcha/api.js?render=${apiKey}&badge=bottomleft`
  script.defer = !0
  script.async = !0
  script.onload = onLoad

  document.head.appendChild(script)
}

const useGoogleRecaptcha = (active: boolean, apiKey: string) => {
  const [grecaptchaInstance, setGrecaptchaInstance] = useState<typeof window.grecaptcha>()

  useEffect(() => {
    if (!active || window.grecaptcha) return

    const onLoad = () => {
      if (!window || !window.grecaptcha) {
        log('Recaptcha script is not available')
        return
      }

      window.grecaptcha.ready(() => {
        setGrecaptchaInstance(window.grecaptcha)
      })
    }

    loadGoogleRecaptchaScript(apiKey, onLoad)
  }, [active, apiKey])

  const executeRecaptcha = useCallback(
    (action: string): Promise<string | undefined> => {
      if (!active) {
        return Promise.resolve(undefined)
      }

      if (!grecaptchaInstance?.execute) {
        log('Google Recaptcha has not been loaded')
        return Promise.resolve(undefined)
      }

      return grecaptchaInstance.execute(apiKey, { action })
    },
    [grecaptchaInstance]
  )

  return {
    grecaptchaInstance,
    executeRecaptcha
  }
}

export default useGoogleRecaptcha
